import type { ReactNode } from 'react';

import { useCan } from '@/features/permissions/useCan';

export interface CanProps {
  action: string;
  resource: string;
  children: ReactNode;
  /** Rendered while the verdict is unresolved (defaults to nothing — no flash). */
  fallback?: ReactNode;
}

/**
 * Hide-mode permission gate (design §14.2/§14.5). Renders children only when
 * the policy engine said yes; renders nothing while unresolved so an entry
 * point never flashes enabled→disabled. Disable-mode (row actions) uses
 * `useCan` directly and wraps the control in a Tooltip.
 */
export function Can({ action, resource, children, fallback = null }: CanProps) {
  const { allowed } = useCan(action, resource);
  return <>{allowed === true ? children : fallback}</>;
}
